/**
 * Pelo regulamento, só participa da Realização Destaque quem tem Acordo de Trabalho híbrido.
 *
 * A regra é afirmativa de propósito: a checagem antiga barrava `PREDEFINIDO` e deixava passar
 * quem não tinha acordo nenhum (campo ausente ou vazio na base de funcionários).
 */
export function hasHybridWorkAgreement(tipoDeAcordo: unknown): boolean {
  return tipoDeAcordo === 'HIBRIDO';
}
